import React, { useEffect, useState } from "react";
import Navbar from "../../features/header/Navbar";
import Footer from "../../features/footer/Footer";
import { selectFloatButton } from "../../features/jobs/jobsActions";
import { useDispatch, useSelector } from "react-redux";
import { getJobs } from "../../features/jobs/jobsSelectors";
import { useMediaQuery } from "react-responsive";
import { setResponsive } from "../store/appReducer";
import NavbarMobile from "../../features/header/NavbarMobile";
import { useLocation } from "react-router-dom";
import { JOBS_ROUTE } from "../api/routeConstants";
import { getMap } from "../../features/map/mapSelector";
import MobileJobFilterButton from "../../features/jobs/components/MobileJobFilterButton";
import MobileSidebarMenu from "../../features/header/MobileSidebarMenu";

export default function Layout({ isOverlayPage, children }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileMapsFilterButton, setShowMobileMapsFilterButton] =
    useState(false);

  const { filters } = useSelector((state) => getJobs(state));
  const { location } = useSelector((state) => getMap(state));

  const isComputer = useMediaQuery({ minWidth: 1000 });
  const isTablet = useMediaQuery({ maxWidth: 999, minWidth: 601 });
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  useEffect(() => {
    dispatch(
      setResponsive({
        isComputer,
        isTablet,
        isMobile,
        isPortrait,
      })
    );
  }, [isComputer, isTablet, isMobile, isPortrait, dispatch]);

  useEffect(() => {
    if (isOverlayPage) return;
    if (isMobile && pathname === JOBS_ROUTE && location.address !== null) {
      setShowMobileMapsFilterButton(true);
    } else {
      setShowMobileMapsFilterButton(false);
    }
  }, [isMobile, isOverlayPage, location.address, pathname]);

  function listenToScrollOnMapPageForMobile() {
    if (
      window.scrollY < 390 &&
      !showMobileMenu &&
      isMobile &&
      pathname === JOBS_ROUTE &&
      location.address !== null
    ) {
      setShowMobileMapsFilterButton(true);
    } else {
      setShowMobileMapsFilterButton(false);
    }
  }

  window.addEventListener("scroll", listenToScrollOnMapPageForMobile);

  return (
    <div
      className="layout-main"
      onClick={() => {
        if (filters.selectedFloatButton) dispatch(selectFloatButton(null));
      }}
    >
      {!isOverlayPage && isComputer && <Navbar />}

      {!isOverlayPage && !isComputer && (
        <NavbarMobile
          isShowSideBar={showMobileMenu}
          setShowSidebar={() => {
            setShowMobileMenu(!showMobileMenu);
          }}
        />
      )}
      {!isOverlayPage && !isComputer && (
        <MobileSidebarMenu
          open={showMobileMenu}
          toggleShowDrawer={setShowMobileMenu}
        />
      )}

      <main className="layout-content">{children}</main>
      {showMobileMapsFilterButton && <MobileJobFilterButton />}
      {!isOverlayPage && <Footer />}
    </div>
  );
}
